import { LicenseException } from '@/domain/licensing/exception/LicenseException'

export class CannotReleaseException extends LicenseException
{

}
